import React from 'react';
import './SocialMediaBtn.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const SocialMediaBtn = (props) =>
    <div className={"SocialMediaBtn"}>
        <a href={props.url} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={props.icon} className={"BtnIcon"}/></a>
    </div>

export default SocialMediaBtn;